import { useTranslation } from "@/i18n/client";
import Select from "@/components/Select";
import { useContext } from "react";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";
import { FormInputProps } from "@/types";
import { InputTooltip } from "@/components/InputTooltip";
import { KETTLE_BRAND } from "@/constants/supplyPoint";

export const KettleBrand = (props: FormInputProps) => {
  const { t } = useTranslation(["supplyPoint", "hints"]);
  const { serviceAttributes } = useContext(EnumerationsContext);

  const kettleBrands = serviceAttributes
    .filter(service => service.attribute === KETTLE_BRAND)
    .map(service => ({
      value: service.value,
      label: service.name,
    }));

  return (
    <InputTooltip
      tooltipProps={{
        label: t("hints:supplyPoint.bundleServicesKettleBrand"),
      }}>
      <Select label={t("supplyPoint:kettleData.kettleBrand")} data={kettleBrands} {...props} />
    </InputTooltip>
  );
};
